import { useFilterData } from '../../../filterContext';
import {
  useDateFromStringState,
  useLocalStorageState,
} from '@msrceng/component';
import { IDateRangeState } from '../../../../../../../api/apiTypes';

/**
 * Logic to get the date state for the date selector when
 * the user is editing the date but hasn't saved yet.
 */
export const useDateSelectorEditDate = (): IDateRangeState => {
  const { startDate: startDateExternal, endDate: endDateExternal } =
    useFilterData().commonFilterState;

  const [storageStartDate, setStorageStartDate] = useLocalStorageState<
    string | undefined
  >('date-selector--start', startDateExternal?.toISOString?.());

  const [storageEndDate, setStorageEndDate] = useLocalStorageState<
    string | undefined
  >('date-selector--end', endDateExternal?.toISOString?.());

  const [startDate, setStartDate] = useDateFromStringState(
    storageStartDate,
    setStorageStartDate
  );
  const [endDate, setEndDate] = useDateFromStringState(
    storageEndDate,
    setStorageEndDate
  );

  return {
    startDate,
    endDate,
    setStartDate,
    setEndDate,
  };
};
